import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";

class MobileSort extends React.Component {

  static propTypes = {
    "selectedFilters": PropTypes.array.isRequired,
    "sort": PropTypes.func.isRequired,
    "sorts": PropTypes.array.isRequired
  };

  renderSortItem = (sortItem) => {
    const {selectedFilters, sort} = this.props;
    const selectedSort = selectedFilters.find(filter => filter.key.indexOf("sort") === 0);

    return (
      <div
        className={`selection${selectedSort && selectedSort.key === sortItem.key ? " averta-semibold" : ""}`}
        key={sortItem.key}
        onClick={() => sort(sortItem.displayName)} // eslint-disable-line react/jsx-no-bind
      >
        {sortItem.displayName}
      </div>
    );
  }

  render () {
    const {sorts} = this.props;

    return (
      <div className="type pv16 pr16">
        <div className="type-title averta-semibold">
          Sort by:
        </div>
        <div className="sort-selections ml16 pt8">
          {sorts.map(sortItem => this.renderSortItem(sortItem))}
        </div>
      </div>
    );
  }
}

const mapStoreToProps = state => ({"selectedFilters": state.selectedFilters || []});

export default connect(mapStoreToProps)(MobileSort);
